<template>
  <div class="mb-6">
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <autocomplete :disabled="editing && !advertisingChannel.supports_update_targeting && acceptanceStatus" id="create-campaign-s3-search-city-input" @submit="addLocation" :search="searchLocation" :getResultValue="() => {return ''}" :placeholder="$t('Search for city, country.')">
          <template #result="{ result, props }">
            <li v-bind="props">
              <div class="wiki-title">
                {{ result.name }}
                <span v-if="result.type && result.type === 'city'">
                  - {{ result.country.name }}
                </span>
              </div>
            </li>
          </template>
        </autocomplete>
      </div>
    </div>

    <div class="vx-row mt-6 mb-10">
      <div class="vx-col mb-8 w-full">
        <span class="suggested-tags">Suggested Tags</span>
      </div>
      <div class="vx-col w-full">
        <div class="region-parent">
          <span
            id="create-campaign-s3-regions-button"
            v-for="(region, index) in regions"
            :key="'span-tag-' + index"
            class="mr-3 span-tag"
            :class="{'span-tag-active' : regionsSelectedLength[region.id] === region.countries_count}"
            @click="regionCountries(region, regionsSelectedLength[region.id] === region.countries_count ? 'remove' : 'add')"
            >
            {{ region.id == 1 ? 'GCC' : region.name }} ({{ regionsSelectedLength[region.id] }} / {{ region.countries_count }})
          </span>
        </div>
      </div>
    </div>

    <div class="vx-row pt-3 h-64 overflow-y-scroll treeContainer mx-0">
      <div class="vx-col w-full">
        <tree v-show="value.countries.length" :data="tree" ref="tree">
          <span class="tree-text" slot-scope="{ node }">
            <template>
              <span v-if="node.data.type === 'city'" class="inline-block align-middle mt-2 mr-2">
                <vs-icon icon-pack="speakol" icon="speakol-map-pin" svgClasses="w-5 h-5"/>
              </span>
              <template v-if="node.data.type === 'country'">
                <i v-if="locations.cities.filter(i => i.country_id == node.data.id).length == 0" class="tree-arrow has-child no-cities ltr"></i>
              </template>
              <span class="inline-block align-middle mr-3">
                {{ node.text }}
              </span>
              <span class="inline-block align-middle" @click="removeLocation(node.data.id, node.data.type === 'city' ? 'cities' : 'countries')">X</span>
            </template>
          </span>
        </tree>
        <div class="text-gray-600 pt-1" v-show="!value.countries.length">
          Display locations you choose..
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    },
    advertisingChannel: {
      type: Object,
      required: false
    },
    acceptanceStatus: {
      type: Boolean,
      required: false
    }
  },
  watch: {
    value: {
      handler (newVal) {
        if (!newVal.countries.length) {
          this.locations.countries = []
        }

        if (!newVal.cities.length) {
          this.locations.cities = []
        }

        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  components: {
    Autocomplete
  },
  data () {
    return {
      locations: {
        countries: [],
        cities: []
      },
      tree: []
    }
  },
  computed: {
    regionsSelectedLength () {
      const status = []

      this.regions.forEach(element => {
        status[element.id] = element.countries.filter(c => this.value.countries.includes(c.id)).length
      })

      return status
    },

    regions () {
      return this.$store.getters['campaign/targetingLookups'].regions
    }
  },
  async created () {
    await this.initSelectedLocations()
  },
  methods: {
    async initSelectedLocations () {

      // after getting regions i need to check if there is countries in the "main state" if there any will trigger a request and select it
      if (this.value.countries.length || this.value.cities.length) {
        const response = await window.axios.post('/recommendations/get/locations', {
          countries: this.value.countries,
          cities: this.value.cities,
          find_by_ids: true,
          hideLoader: true
        })

        response.data.payload.forEach(item => {
          this.addLocation(item)
        })
      }
    },
    async searchLocation (input) {
      let payload = []

      if (!(input.length < 3)) {
        const response = await window.axios.post('/recommendations/get/locations', {
          keyword: input,
          find_by_ids: false,
          hideLoader: true
        })

        payload = response.data.payload
      }

      return new Promise(resolve => {
        return resolve(payload)
      })
    },
    addCountry (item) {
      return new Promise(resolve => {
        if (this.locations.countries.find(i => item.id === i.id) && this.value.countries.find(i => item.id === i)) {
          return resolve(true)
        }

        if (!this.value.countries.find(i => item.id === i)) {
          this.value.countries.push(item.id)
        }

        if (!this.locations.countries.find(i => item.id === i.id)) {
          this.locations.countries.push(item)
        }

        if (this.$refs.tree.find(item.name).length === 0) {
          this.$refs.tree.prepend({
            text: item.name,
            data: item
          })
        }

        return resolve(true)
      })
    },
    addCity (item) {
      // check if item exists
      if (this.locations.cities.find(i => item.id === i.id) && this.value.cities.find(i => item.id === i)) {
        return
      }

      this.addCountry(item.country).then(() => {
        if (!this.value.cities.find(i => item.id === i)) {
          this.value.cities.push(item.id)
        }

        if (!this.locations.cities.find(i => item.id === i.id)) {
          this.locations.cities.push(item)
        }

        const node = this.$refs.tree.find(item.country.name)

        if (node.length && this.$refs.tree.find(item.name).length === 0) {
          node[0].prepend({
            text: item.name,
            data: item
          })
        }
      })
    },
    addLocation (item) {
      // add the item to the main state => form.step3.adsets[adsetIndex].locations
      if (item.type === 'city' && typeof item.country === 'object') {
        this.addCity(item)
        return
      }

      // in case country
      this.addCountry(item)
    },
    removeLocation (id, type) {
      if (this.editing && !this.advertisingChannel.supports_update_targeting && this.acceptanceStatus) {
        return
      }
      // this.$refs.tree
      const nodeName = this.locations[type].find(i => i.id === id).name
      const node = this.$refs.tree.find(nodeName)
      if (node.length) {
        this.$refs.tree.remove(nodeName)
      }

      // this.locations[type]
      const index = this.locations[type].findIndex(i => i.id === id)
      this.locations[type].splice(index, 1)

      // this.value[type]
      const vindex = this.value[type].findIndex(i => i === id)
      this.value[type].splice(vindex, 1)


      // remove the country cities => this.locations.cities, this.value.cities
      if (type === 'countries') {
        this.locations.cities.filter(c => c.country && c.country_id === id).forEach(element => {
          this.removeLocation(element.id, 'cities')
        })
      }
    },
    regionCountries (region, type) {
      if (this.editing && !this.advertisingChannel.supports_update_targeting && this.acceptanceStatus) {
        return
      }
      region.countries.forEach(element => {
        if (type === 'add') {
          element.type = 'country'
          this.addCountry(element)
        } else {
          this.removeLocation(element.id, 'countries')
        }
      })
      if (region.id === 1) {
        this.$gtag.event('Step3_LocationTab_GCC')
      } else if (region.id === 2) {
        this.$gtag.event('Step3_LocationTab_Europe')
      } else if (region.id === 3) {
        this.$gtag.event('Step3_LocationTab_MENA')
      }
    }
  }
}

</script>

<style lang="scss">
  .no-cities::after {
    border: 1.5px solid #ccc !important;
    border-left: 0 !important;
    border-top: 0 !important;
    left: -30px !important;
  }

  .suggested-tags {
    color: #2c2c2c;
  }

  .autocomplete-input::placeholder {
    color: rgba(0, 0, 0, 0.2);
    opacity: 1;
  }
</style>
